import './index.css';

const RadioniceDodatno = () => {
    return (
        <>
            <div className="row">
                <div className="col-md-12 col-td-12 col-12">
                    <h2>Postavljanje konstelacija</h2>
                    <p>Rad se može postaviti grupno ili individualno, uživo ili online</p>
                    <p>
                        Radom u grupi dobijete energetsku i emocionalnu podršku drugih sudionika, dobijete priliku
                        učestvovati ili samo promatrati radove drugih sudionika u kojima možete dobiti snažne i važne
                        uvide.
                    </p>
                    <p>
                        Kroz individualni rad dobijete mirniji i intimniji prostor za rad. Za sve koji se boje ili ne
                        mogu otvoriti prema grupi, individualni rad je dobar odabir.{' '}
                    </p>
                    <p>
                        Bez obzira KAKO postavljate rad, najvažnije za uspjeh rada je JASNA UNUTARNJA NAMJERA i volja za
                        promjenom.
                    </p>
                    <p>
                        Ponekad nam to dođe kao osjećaj „već mi je ovoga dosta“, ponekad „ne želim ovu bol“ ili „vrijeme
                        je za promjene“ ili „umorna sam od pokušaja! Ili… Bez obzira kako se namjera uobliči, opustite
                        misli, otvorite srce, otvorite se prema onom što može doći.
                    </p>
                    <p>
                        Neće doći ni previše ni premalo, doći će ono što trebate, koliko trebate i u obliku u kojem
                        trebate.
                    </p>
                </div>
            </div>
        </>
    );
};

export default RadioniceDodatno;
